(function () {
  const MIN_ORDER_CENTS = 15000;

  let cartSubtotal = 0;

  function getServiceVariantIds() {
    const notice = document.querySelector('[data-ksp-minimum-order-notice]');
    const shipBox = document.querySelector('[data-ksp-shipping-hinweis]');
    const raw =
      notice?.dataset.serviceVariantIds ||
      [
        shipBox?.getAttribute('data-avisierung-variant-id'),
        shipBox?.getAttribute('data-premium-variant-id'),
      ]
        .filter(function (id) {
          return id && id !== '0';
        })
        .join(',');

    return String(raw || '')
      .split(',')
      .map(function (id) {
        return Number(id);
      })
      .filter(Boolean);
  }

  function merchandiseSubtotalFromCart(cart) {
    if (!cart || !cart.items) return 0;
    const serviceIds = getServiceVariantIds();

    return cart.items.reduce(function (sum, item) {
      if (serviceIds.indexOf(Number(item.variant_id)) !== -1) return sum;
      return sum + (item.final_line_price || 0);
    }, 0);
  }

  function merchandiseItemCount(cart) {
    if (!cart || !cart.items) return 0;
    const serviceIds = getServiceVariantIds();

    return cart.items.reduce(function (count, item) {
      if (serviceIds.indexOf(Number(item.variant_id)) !== -1) return count;
      return count + 1;
    }, 0);
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
    }).format(cents / 100);
  }

  function isMinimumReached(subtotal, itemCount) {
    return itemCount > 0 && subtotal >= MIN_ORDER_CENTS;
  }

  function updateCheckoutButtons(reached) {
    document.querySelectorAll('#checkout, [name="checkout"]').forEach(function (button) {
      if (button.closest('.is-empty')) return;
      button.disabled = !reached;
      button.setAttribute('aria-disabled', reached ? 'false' : 'true');
    });

    document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach(function (wrapper) {
      wrapper.hidden = !reached;
    });
  }

  function updateNotice(subtotal, itemCount) {
    const reached = isMinimumReached(subtotal, itemCount);
    const remaining = Math.max(0, MIN_ORDER_CENTS - subtotal);

    document.querySelectorAll('[data-ksp-minimum-order-notice]').forEach(function (notice) {
      if (itemCount === 0) {
        notice.hidden = true;
        return;
      }

      notice.hidden = reached;
      notice.dataset.cartSubtotal = String(subtotal);

      const remainingEl = notice.querySelector('[data-ksp-minimum-remaining]');
      if (remainingEl) {
        remainingEl.textContent = formatMoney(remaining);
      }
    });

    updateCheckoutButtons(reached);
  }

  function applyFromCart(cart) {
    if (!cart) return;
    cartSubtotal = merchandiseSubtotalFromCart(cart);
    updateNotice(cartSubtotal, merchandiseItemCount(cart));
  }

  function initFromDom() {
    fetch((window.routes?.cart_url || '/cart') + '.js')
      .then(function (response) {
        return response.json();
      })
      .then(applyFromCart)
      .catch(function () {
        const notice = document.querySelector('[data-ksp-minimum-order-notice]');
        if (!notice) return;

        const subtotal = Number(notice.dataset.cartSubtotal || 0);
        cartSubtotal = subtotal;
        updateNotice(subtotal, subtotal > 0 ? 1 : 0);
      });
  }

  document.getElementById('cart')?.addEventListener('submit', function (event) {
    const submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    if (cartSubtotal < MIN_ORDER_CENTS) {
      event.preventDefault();
      document.querySelector('[data-ksp-minimum-order-notice]')?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event.cartData?.items) {
        applyFromCart(event.cartData);
        return;
      }

      fetch((window.routes?.cart_url || '/cart') + '.js')
        .then(function (response) {
          return response.json();
        })
        .then(applyFromCart)
        .catch(function () {});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFromDom);
  } else {
    initFromDom();
  }
})();
